export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./~/d3-color/src/math.js
// module id = 618
// module chunks = 0